import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "dashboard-content bg-white dark:bg-(--color-dark-bg-primary)" };
import { onMounted } from "vue";
import { useAccountInfo } from "@/shared/composables/useAccountInfo";
import { useLogger } from "@/shared/composables/useLogger";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Dashboard',
    setup(__props) {
        const logger = useLogger();
        const { fetchAccountInfo } = useAccountInfo();
        onMounted(async () => {
            try {
                await fetchAccountInfo();
            }
            catch (error) {
                logger.debug("Failed to load account information on dashboard mount");
            }
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_router_view)
            ]));
        };
    }
});
